<app-loader></app-loader>
<div class="dashboard-home-wrapper">
  <header class="site-header shadow-sm">
    <div class="container-fluid d-flex align-items-center justify-content-between py-2">
      <a routerLink="/" class="d-flex align-items-center text-decoration-none">
        <img src="assets/images/odishalogo.png" class="logo me-2" alt="Odisha logo" />
        <div class="lh-sm">
          <span class="h5 mb-0 fw-bold text-success">Odisha Wildlife Organization</span><br />
          <small class="text-muted">Official Website of PCCF&nbsp;(Wildlife) &amp; CWW, Odisha</small>
        </div>
      </a>

    </div>
  </header>

  <main class="landing-dashboard container py-6">
    <section class="bg-light bg-glass rounded-4 p-4 p-lg-5 shadow-lg overflow-hidden">
      <h2 class="text-center fw-bold mb-5 text-success display-6">Integrated Wildlife Management System</h2>
      
      <div class="row g-4 justify-content-center">
        <div class="col-sm-6 col-lg-4 mb-4" *ngFor="let m of modules">
          <div class="card border-0 module-card" (click)="onCardClick(m)" [ngStyle]="{'background-image': 'url(' + m.image + ')', 'background-size': 'cover', 'background-position': 'center', 'background-repeat': 'no-repeat'}">
          </div>
        </div>
      </div>

    </section>
    <app-login [selectedModule]="selectedModule"></app-login>
  </main>
<footer class="main-footer">
    <div class="widgets-section">
        <div class="container">
            <div class="row">
                <!--Big Column-->
                <div class="big-column col-md-6 col-sm-12 col-xs-12">
                    <div class="row clearfix">

                        <!--Footer Column-->
                        <div class="col-md-12 col-sm-6 col-xs-12">

                            <div class="footer-widget about-column">
                                <div class="section-title">
                                    <h4>Quick Contact</h4>
                                </div>
                                <ul class="contact-info">
                                    <li>
                                        <span class="fa fa-map-marker"></span>Office of the principal chief conservator
                                        of forests (Wildlife) and chief wildlife warden, Odisha<br>Prakruti Bhawan, Plot
                                        No - 1459, Saheed Nagar, Bhubaneswar - 751007, Odisha, India
                                    </li>
                                    <li>
                                        <span class="fa fa-volume-control-phone"></span> 
                                        <strong>PCCF (WL) & CWLW : </strong> 0674 2602251<br>
                                        <strong>Addl. PCCF : </strong>0674 2602252<br>
                                        <div class="text-warning"><strong>Toll Free No. : </strong>18003456771</div>
                                    </li>
                                    <li>
                                        <span class="fa fa-envelope"></span>odishawildlife&#64;gmail.com
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!--Footer Column-->
                        <!-- <div class="col-md-6 col-sm-6 col-xs-12">
                            <div class="footer-widget link-column">
                                <div class="section-title">
                                    <h4>Quick Links</h4>
                                </div>
                                <div class="widget-content">
                                    <ul class="list">
                                        <li><a [routerLink]="['/projectelephant']">Project Elephant</a></li>
                                        <li><a [routerLink]="['/projecttiger']">Project Tiger</a></li>
                                        <li><a [routerLink]="['/crocodileconservation']">Crocodile Conservation</a></li>
                                        <li><a [routerLink]="['/seaturtleconservation']">Sea Turtle Conservation</a>
                                        </li>
                                        <li><a [routerLink]="['/blackbuckconservation']">Blackbuck Conservation</a></li>
                                        <li><a [routerLink]="['/mangroves']">Mangroves</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>

                <!--Big Column-->
                <div class="col-md-6 offset-md-4 text-center mt-3">

                    <!-- <div class="subscription">
                        <label>Subscribe to us</label>
                        <form>
                            <input type="email" id="" class="form-control" placeholder="example@gmail.com">
                            <button value="submit" class="btn btn-light">Subscribe</button>
                        </form>
                    </div> -->
                    <ul class="social-icon mt-2">
                        <li><a href="https://www.facebook.com/pccfwildlifeodisha" target="_blank"><i class="mdi mdi-facebook"></i></a></li>
                        <li><a href="https://twitter.com/odishawildlife" target="_blank"><i class="mdi mdi-twitter"></i></a></li>
                        <li><a href="https://www.youtube.com/c/WildlifeOdisha" target="_blank"><i class="mdi mdi-youtube"></i></a></li>
                    </ul>

                </div>
            </div>
        </div>
    </div>
</footer>
<section class="footer-bottom">
    <div class="container">
        <div class="row">
            <div class="col-md-8">
                <div class="text-left copy-text">
                    <p>Copyrights &copy; {{ currentYear }} | Odisha Wildlife Organization | All Rights Reserved
                        <!-- | Developed by <a href="https://sparcindia.com/" target="_blank">SPARC (P) Ltd.</a> -->
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="text-right get-text">
                    Visitor Count : <a href="#">45102</a>
                </div>
            </div>
        </div>
    </div><!-- /.container -->
</section>

<button class="scrollup" style="display: block;"><span class="fa fa-angle-up"></span></button>
</div>
